import type { SceneDef, StoryPack } from '@plotjack/core';
import { castFor, castShortRole, scenePosition } from '@plotjack/core';

interface Props {
  story: StoryPack;
  scene: SceneDef;
  sceneIndex: number;
  onOpenLog: () => void;
  logCount: number;
}

/** Always-on answer to "what am I doing and where am I". */
export function QuestPanel({ story, scene, sceneIndex, onOpenLog, logCount }: Props) {
  const pos = scenePosition(story, sceneIndex);
  const villain = castFor(story, 'villain');
  const hero = castFor(story, 'hero');
  return (
    <section className="quest-panel" aria-label="Quest">
      <div className="quest-panel__main">
        <p className="quest-panel__quest">
          <span className="quest-label">Quest</span> {story.quest}
        </p>
        {hero && villain && (
          <p className="quest-panel__stakes">
            <span className="quest-label">Hero</span> {hero.name}
            <span className="quest-panel__dot" aria-hidden="true"> · </span>
            <span className="quest-label">Antagonist</span> {villain.name}, {castShortRole(villain.role)}
          </p>
        )}
        {scene.goal && (
          <p className="quest-panel__goal">
            <span className="quest-label quest-label--now">Now</span> {scene.goal}
          </p>
        )}
      </div>
      <div className="quest-panel__side">
        <p className="quest-panel__where">
          Chapter {pos.chapterNumber}, Scene {pos.sceneInChapter} of {pos.scenesInChapter}
          <span className="quest-panel__chapter">{pos.chapterTitle}</span>
        </p>
        <button type="button" className="btn btn-ghost btn-small" onClick={onOpenLog}>
          Story so far{logCount ? ` (${logCount})` : ''}
        </button>
      </div>
    </section>
  );
}
